module.exports = __webpack_public_path__ + "img/ic-logo-tazapay.52e41eda.svg";